import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { useKaannos } from '../lib/i18n';
import { kentta, nappiEnsisijainen } from '../lib/tyylit';

/**
 * Paikallinen kirjautuminen salasanalla (suunnitelma 13.2.1).
 *
 * Näkyy vain kun palvelin kertoo `/auth/methods`issa, että tapa on
 * käytössä. Toisin kuin kehityskirjautuminen, tämä ei ole ohitus eikä siis
 * rajattu kehityskäännökseen.
 */
export default function PaikallinenKirjautuminen({ paluu }: { paluu: string }) {
  const { t } = useKaannos();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [virhe, setVirhe] = useState<string | null>(null);
  const [lahetetaan, setLahetetaan] = useState(false);

  async function kirjaudu(event: React.FormEvent) {
    event.preventDefault();
    setVirhe(null);
    setLahetetaan(true);
    try {
      await api.post('/auth/local-login', { email: email.trim(), password });
      // Kova lataus, jotta koko välimuisti lähtee puhtaalta pöydältä.
      // Jos salasana on pakko vaihtaa, `/api/me` kertoo sen ja kehys
      // ohjaa vaihtolomakkeelle.
      window.location.assign(paluu);
    } catch (error) {
      setVirhe(error instanceof ApiError ? error.message : t('kirjautuminen.virheYleinen'));
      setLahetetaan(false);
    }
  }

  return (
    <form onSubmit={kirjaudu} className="space-y-3">
      <label className="block">
        <span className="text-teksti mb-1 block text-sm font-medium">
          {t('yleinen.sahkoposti')}
        </span>
        <input
          type="email"
          required
          autoComplete="username"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          className={kentta}
        />
      </label>

      <label className="block">
        <span className="text-teksti mb-1 block text-sm font-medium">
          {t('kirjautuminen.salasana')}
        </span>
        <input
          type="password"
          required
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          className={kentta}
        />
      </label>

      {virhe && (
        <p
          role="alert"
          className="border-yli/40 bg-yli/10 text-teksti rounded-md border px-3 py-2 text-sm"
        >
          {virhe}
        </p>
      )}

      <button type="submit" disabled={lahetetaan} className={`${nappiEnsisijainen} w-full`}>
        {lahetetaan ? t('kirjautuminen.kirjaudutaan') : t('kirjautuminen.kirjaudu')}
      </button>
    </form>
  );
}
